(function () {
  "use strict";

  const ROOT_SELECTOR = "[data-kit-set-g1-experience]";
  const TRACK_SELECTOR = "[data-g1-experience-track]";
  const MOBILE_MQ = "(max-width: 720px)";

  function unbindDrag(section) {
    if (typeof section.__kitSetG1ExpDragCleanup === "function") {
      section.__kitSetG1ExpDragCleanup();
      section.__kitSetG1ExpDragCleanup = null;
    }
  }

  /** 移动端 pointer 拖拽：DevTools 模拟器鼠标拖动也能横滑 */
  function bindDrag(section) {
    var wrap = section.querySelector(TRACK_SELECTOR);
    if (!wrap) return;

    unbindDrag(section);

    if (!window.matchMedia(MOBILE_MQ).matches) return;

    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;
    var pointerId = null;

    function onPointerDown(event) {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      dragging = true;
      moved = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = wrap.scrollLeft;
      wrap.classList.add("is-dragging");
      try {
        wrap.setPointerCapture(event.pointerId);
      } catch (err) {}
    }

    function onPointerMove(event) {
      if (!dragging || (pointerId !== null && event.pointerId !== pointerId)) return;
      var dx = event.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      wrap.scrollLeft = startScroll - dx;
      if (moved) event.preventDefault();
    }

    function onPointerUp(event) {
      if (!dragging || (pointerId !== null && event.pointerId !== pointerId)) return;
      dragging = false;
      pointerId = null;
      wrap.classList.remove("is-dragging");
      try {
        wrap.releasePointerCapture(event.pointerId);
      } catch (err) {}
    }

    function onClickCapture(event) {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }

    wrap.addEventListener("pointerdown", onPointerDown);
    wrap.addEventListener("pointermove", onPointerMove, { passive: false });
    wrap.addEventListener("pointerup", onPointerUp);
    wrap.addEventListener("pointercancel", onPointerUp);
    wrap.addEventListener("click", onClickCapture, true);

    section.__kitSetG1ExpDragCleanup = function () {
      wrap.removeEventListener("pointerdown", onPointerDown);
      wrap.removeEventListener("pointermove", onPointerMove);
      wrap.removeEventListener("pointerup", onPointerUp);
      wrap.removeEventListener("pointercancel", onPointerUp);
      wrap.removeEventListener("click", onClickCapture, true);
      wrap.classList.remove("is-dragging");
    };
  }

  function initSection(section) {
    if (!section) return;
    bindDrag(section);

    if (!section.__kitSetG1ExpResizeBound) {
      section.__kitSetG1ExpResizeBound = true;
      var frame = 0;
      window.addEventListener("resize", function () {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          bindDrag(section);
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target.querySelector(ROOT_SELECTOR) || event.target.closest(ROOT_SELECTOR));
  });
})();
